import ArticleService from "../../service/ArticleService";
import { Notification } from 'element-ui';
export class ArticleList {
  list = [];
  total = 0;
  is_none = false
  draft_total = 0;
  constructor(params) {
    this.getList(params)
  }

  async getList(params) {
    this.list = []
    this.total = 0
    const res = await ArticleService.getList(params)
    if (res.code === 1) {
      this.list = res.data.list
      this.total = res.data.count
      this.is_none = false
      this.draft_total = res.data.draft_total
      if (this.total <= 0) this.is_none = true
    }
  }

  // 修改文章状态
  editStatus (query) {
    return ArticleService.editStatus(query)
  }

  // 修改文章私密状态
  editSecret (query) {
    return ArticleService.editSecret(query)
  }

  // 彻底删除
  del(id) {
    return ArticleService.del({ id })
  }

  
  // 移到回收站
  remove(id) {
    return ArticleService.remove({ id })
  }
}